import classNames from "classnames";
import "./services.scss";

export const Services = () => {
	return (
		<div className={"container"}>
			<h2 className={classNames("subtitle-2", "table-header")}>
				ПРЕЙСКУРАНТ на ортопедические услуги в ИП Горохов М.Ю.
			</h2>
			<table className={"price-table"}>
				<colgroup>
					<col style={{ width: "14%" }} />
					<col style={{ width: "76%" }} />
					<col style={{ width: "8%" }} />
				</colgroup>
				<tbody>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование частичными съёмными пластиночными протезами (1
									челюсть)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>18000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование частичными съёмными пластиночными протезами с
									армированием
								</strong>
							</p>
							<p>
								<strong>(1 челюсть)</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>19000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование частичными съёмными пластиночными протезами из
									нейлона{" "}
								</strong>
							</p>
							<p>
								<strong>(1 челюсть)</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>28000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.023</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование зубов полными съёмными пластиночными протезами
									(1 челюсть)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>20000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.023</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование зубов полными съёмными пластиночными протезами
									с армированием (1 челюсть)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>22000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.023</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование зубов полными съёмными пластиночными протезами
									из нейлона
								</strong>
							</p>
							<p>
								<strong>(1 челюсть)</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>31000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.036</p>
						</td>
						<td>
							<p>
								<strong>
									Протезирование съёмными бюгельными протезами с замковой
									фиксацией (1 челюсть)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>52000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.028</p>
						</td>
						<td>
							<p>
								<strong>
									Снятие коронки (цельнометаллической, металлокерамической) 1
									единица
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.028</p>
						</td>
						<td>
							<p>
								<strong>Снятие штампованной коронки - 1 единица</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>600,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.053</p>
						</td>
						<td>
							<p>
								<strong>
									Снятие несъёмной ортопедической конструкции с импланта
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1400,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.092</p>
						</td>
						<td>
							<p>
								<strong>
									Трепанация зуба, трепанация искусственной коронки
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>800,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.049</p>
						</td>
						<td>
							<p>
								<strong>
									Повторная фиксация на постоянный цемент несъёмных
									ортопедических конструкций (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.049</p>
						</td>
						<td>
							<p>
								<strong>
									Повторная фиксация на постоянный цемент несъёмных
									ортопедических конструкций с опорой на имплантах (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1400,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.049</p>
						</td>
						<td>
							<p>
								<strong>
									Временная фиксация ортопедических конструкций (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>600,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.035</p>
						</td>
						<td>
							<p>
								<strong>Приварка кламера</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1100,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.036</p>
						</td>
						<td>
							<p>
								<strong>Приварка зуба</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1100,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.037</p>
						</td>
						<td>
							<p>
								<strong>
									Починка перелома базиса самотвердеющей пластмассой
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1100,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>Эластичная прокладка для съёмного протеза</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>Полировка пластиночного протеза</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>700,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>Профессиональная чистка съёмного протеза</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>700,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.035</p>
						</td>
						<td>
							<p>
								<strong>Замена матрицы</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1200,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07035</p>
						</td>
						<td>
							<p>
								<strong>Искусственная керамическая десна</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>2200,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А02.07.010.001</p>
						</td>
						<td>
							<p>
								<strong>
									Снятие оттиска с одной челюсти альгинатной массой
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>400,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А02.07.010.001</p>
						</td>
						<td>
							<p>
								<strong>
									Снятие оттиска с одной челюсти массой из С-силикона
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1800,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.033</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба с использованием цельнолитой культевой
									вкладки (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>2900,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.033</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба с использованием культевой вкладки,
									разборной (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>4300,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.033</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой временным прямым методом (1
									единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>700,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.033</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой временной композитной
									фрезерованной лабораторным методом (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>2200,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.028</p>
						</td>
						<td>
							<p>
								<strong>Изготовление коронки цельнолитой</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>7200,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.054</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой постоянной цельнометаллической с
									напылением{" "}
								</strong>
							</p>
							<p>
								<strong>(1 единица)</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>7700,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.054</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой постоянной металлокерамической (1
									единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>10300,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.054</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой постоянной безметалловой из
									диоксида циркония
								</strong>
							</p>
							<p>
								<strong>(1 единица)</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>20000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.054</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой постоянной безметалловой Имакс с
									индивидуальной эстетикой (метод нанесения) - (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>22800,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.054</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба коронкой постоянной безметалловой из
									диоксида циркония с индивидуальной эстетикой (1 единица)
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>23800,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.002.030</p>
						</td>
						<td>
							<p>
								<strong>Изготовление коронки пластмассовой</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1200,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А23.07.030</p>
						</td>
						<td>
							<p>
								<strong>
									Использование индивидуальной ложки при снятии оттиска с одной
									челюсти
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>1800,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.036</p>
						</td>
						<td>
							<p>
								<strong>Бюгельный протез &nbsp;с кламмерной фиксацией</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>40000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А 23.07.002.034</p>
						</td>
						<td>
							<p>
								<strong>Перебазировка съёмного протеза </strong>
							</p>
						</td>
						<td>
							<p>
								<strong>900,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.003</p>
						</td>
						<td>
							<p>
								<strong>Восстановление зуба виниром </strong>
								<strong>I</strong>
								<strong>-</strong>
								<strong>MAX</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>23000,00</strong>
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>А16.07.003</p>
						</td>
						<td>
							<p>
								<strong>
									Восстановление зуба вкладкой из диоксида циркония
								</strong>
							</p>
						</td>
						<td>
							<p>
								<strong>5800,00</strong>
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};
